import { IncomingMessage } from 'http';

import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';

import { fetchVersions } from '../../../services/vehicles';

const getVersions = (
  options: {
    locale: string;
    model: string;
  },
  req?: IncomingMessage
): [
  QueryKey,
  (options: QueryFunctionContext) => ReturnType<typeof fetchVersions>
] => [
  ['versions', { locale: options.locale, slug: options.model }],
  ({
    queryKey: [, key],
  }: {
    queryKey: [string, { locale: string; slug: string }];
  }) => fetchVersions(key, req),
];

export default getVersions;
